var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../I18N";
import { isString } from 'lodash';
import { InputError } from "./InputError";



















const renderChild = (child) =>
isString(child) ? /*#__PURE__*/_jsx(Translate, {}, void 0, child) : child;

const InputField = /*#__PURE__*/React.forwardRef(
  (
  {
    id,
    label,
    disabled,
    hideLabel,
    placeholder,
    hasErrors,
    errorMessage,
    value,
    className = '',
    type = 'text',
    autoComplete = 'on',
    name = '',
    clearFieldAction,
    onChange = () => {},
    onBlur = () => {}
  },
  ref) =>
  {
    let fieldStyles = 'border-gray-300 border text-gray-900 focus:ring-primary-500 bg-gray-50';
    let clearFieldStyles = 'enabled:hover:text-primary-700 text-gray-900';
    let labelStyles = 'block mb-2 text-sm font-medium text-gray-700';

    if (hasErrors || errorMessage) {
      fieldStyles =
      'border-error-300 focus:border-error-500 focus:ring-error-500 border-2 text-error-900 bg-error-50 placeholder-error-700';
      clearFieldStyles = 'enabled:hover:text-error-700 text-error-900';
      labelStyles = 'block mb-2 text-sm font-medium text-error-700';
    }

    if (clearFieldAction) {
      fieldStyles = `${fieldStyles} pr-10`;
    }

    return /*#__PURE__*/(
      _jsx("div", { className: className }, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: id, className: hideLabel ? 'sr-only' : labelStyles }, void 0,
      renderChild(label)
      ), /*#__PURE__*/
      _jsx("div", { className: "relative w-full" }, void 0, /*#__PURE__*/
      React.createElement("input", {
        type: type,
        autoComplete: autoComplete,
        id: id,
        onChange: onChange,
        onBlur: onBlur,
        name: name,
        ref: ref,
        disabled: disabled,
        value: value,
        className: `${fieldStyles} disabled:text-gray-500 rounded-lg block flex-1 w-full text-sm p-2.5`,
        placeholder: placeholder }
      ),
      Boolean(clearFieldAction) && /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: clearFieldAction,
        disabled: disabled,
        "data-testid": "clear-field-button",
        className: `${clearFieldStyles} top-px disabled:text-gray-500 absolute p-2.5 right-0 text-sm font-medium rounded-r-lg
             focus:outline-none` }, void 0, /*#__PURE__*/

      _jsx(XMarkIcon, { className: "w-5" }), /*#__PURE__*/
      _jsx(Translate, { className: "sr-only" }, void 0, "Clear")
      ),

      errorMessage && /*#__PURE__*/_jsx(InputError, {}, void 0, errorMessage)
      )
      ));

  }
);

export { InputField };